import React from 'react'
import Radio from '@material-ui/core/Radio'
import { useDispatch, useSelector } from 'react-redux'

import styles from './RadioSelect.module.scss'
import * as SettingsAction from './../../SettingsAction'
import { ReactComponent as Timezone } from '../../../../assets/svgs/time_zone.svg'
import I18n from 'i18n-js'

const TimezoneRadioSelect = (props) => {
	const {
		timezone,
	} = useSelector(state => state.SettingsReducer)
	const dispatch = useDispatch()

	const handleChange = async (value) => {
		await dispatch(SettingsAction.setTimezone(value));
		setTimeout(()=>{
			window.location.reload(true);
		},200)
		props.handleClose()

	}
	return (
		<div style={{
			"overflow-y": "scroll",
			"height": "270px"
		}}>
			{props.timezones.map((tmz) => (
				<div className={styles.row} onClick={() => {
					handleChange(tmz.timezone)
				}}>
					<div className={styles.icon}>
						<Timezone width={24} height={24}/>
						<div className={styles.title}>
							<h5>{tmz.timezone.split('/')[1] + " - " + tmz.timezone.split('/')[0]}</h5>
						</div>
					</div>
					<Radio
						checked={timezone === tmz.timezone}
						onChange={(event) => {
							handleChange(event.target.value)
						}}
						value={tmz.timezone}
						color="primary"
						name="radio-button-demo"
						// inputProps={{ 'aria-label': 'E' }}
						// size="small"
					/>

				</div>
			))}
		</div>
	)
}

export default TimezoneRadioSelect
